export default __webpack_public_path__ + "static/media/greenEks.f3049731.svg";